import type { JSX } from "preact";

type IconProps = JSX.SVGAttributes<SVGSVGElement>;

export function IcoSearch({ class: className, ...props }: IconProps) {
  return (
    <svg
      class={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      aria-hidden="true"
      {...props}
    >
      <circle cx="11" cy="11" r="8" />
      <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-4.3-4.3" />
    </svg>
  );
}
